// extracted by mini-css-extract-plugin
export var chatHtmlText = "_qt-2";
export var chatLink = "_qt-0";
export var chatText = "_qt-1";